import React, { useState } from 'react';
import { Row, Col, Container } from 'reactstrap';
import Image from '../UI/Image';
import { imgUrlGenerate, addEllipses } from '../../helpers';
import styles, { img, point, hover } from './ItemDetailsView.module.css';
import { string } from 'prop-types';

const ItemDetailsView = ({ item: [{ name, country, description, price, url }] }) => {
  const [descrFull, setDescrFull] = useState(false)

  return (
    <section className={styles.items}>
      <Container>
        <Row>
          <Col lg={{ size: 5, offset: 1 }}>
            <Image className={img} src={url} alt="coffee_item" />
          </Col>
          <Col lg={{ size: 6 }}>
            <div className="title">About it</div>
            <Image className="beans-logo" src={imgUrlGenerate(`Beans_logo_dark.svg`)} alt="Beans logo" />
            <h2>{name}</h2>
            <div className={point}>
              <span>Country:</span> {country}
            </div>
            <div
              className={!descrFull ? `${point} ${hover}` : point}
              onClick={() => setDescrFull(descrFull => !descrFull)}
            >
              <span>Description: </span>
              {(description.length > 200 && !descrFull) ? addEllipses(description) : description}
            </div>
            <div className={point}>
              <span>Price:</span>&nbsp;
            <span className={styles.price}>{price}</span>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

ItemDetailsView.propTypes = {
  name: string,
  country: string,
  description: string,
  price: string,
  url: string,
}

ItemDetailsView.defaultProps = {
  name: '',
  country: '',
  description: '',
  price: '',
  url: '',
}

export default ItemDetailsView